/* unplugin-vue-components disabled */import script from "./detail.vue?vue&type=script&name=AlarmDetail&setup=true&lang=js"
export * from "./detail.vue?vue&type=script&name=AlarmDetail&setup=true&lang=js"

import "./detail.vue?vue&type=style&index=0&id=0a72f5aa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a72f5aa"]])

export default __exports__